function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M65.2962 38.1912H43.9833V0.513428H65.2962V5.71926H50.1426V15.9763H64.3427V21.1306H50.1426V32.9597H65.2962V38.1912ZM97.7219 0.513428V24.8932C97.7219 27.6765 97.1205 30.1162 95.9179 32.2123C94.7324 34.2912 93.0057 35.8976 90.7378 37.0315C88.4871 38.1483 85.7897 38.7067 82.6456 38.7067C77.9724 38.7067 74.3386 37.4697 71.7443 34.9956C69.1499 32.5215 67.8528 29.1197 67.8528 24.7901V0.513428H74.0379V24.352C74.0379 27.4617 74.7595 29.7554 76.2027 31.233C77.6459 32.7105 79.8623 33.4493 82.8517 33.4493C88.6589 33.4493 91.5625 30.3997 91.5625 24.3005V0.513428H97.7219ZM102.082 0.513428V38.1912H108.242V23.3191H112.937V38.1912H119.097V24.0943H123.014C127.773 24.0943 131.441 23.0462 134.018 20.9502C136.595 18.8541 137.884 15.8388 137.884 11.9044C137.884 8.15895 136.707 5.32409 134.353 3.39983C132.017 1.47556 128.495 0.513428 123.787 0.513428H112.937V18.9208H108.242V0.513428H102.082ZM119.097 18.9142H122.37C125.531 18.9142 127.85 18.3644 129.328 17.2649C130.805 16.1653 131.544 14.4472 131.544 12.1106C131.544 9.94577 130.883 8.33076 129.56 7.26554C128.237 6.20032 126.175 5.66771 123.375 5.66771H119.097V18.9142ZM163.97 38.1912H171.521V0.513428H165.877V20.2543C165.877 21.646 165.929 23.5874 166.032 26.0787C166.135 28.5527 166.203 29.9873 166.238 30.3825H166.083L147.605 0.513428H140.131V38.1912H145.724V18.605C145.724 15.9591 145.603 13.0383 145.363 9.84268L145.234 8.16754H145.44L163.97 38.1912Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M53.8022 60.7048H45.9258V46.5756H53.8022V48.0349H47.5687V52.5868H53.4253V54.0364H47.5687V59.2358H53.8022V60.7048Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M66.227 46.5756V55.718C66.227 57.3287 65.7405 58.5948 64.7677 59.5161C63.7948 60.4374 62.4579 60.8981 60.757 60.8981C59.0561 60.8981 57.7385 60.4342 56.8043 59.5064C55.8765 58.5787 55.4126 57.303 55.4126 55.6794V46.5756H57.0556V55.7953C57.0556 56.9744 57.3777 57.8796 58.022 58.511C58.6663 59.1424 59.6134 59.4581 60.8633 59.4581C62.0552 59.4581 62.9733 59.1424 63.6176 58.511C64.2619 57.8732 64.584 56.9615 64.584 55.776V46.5756H66.227Z",
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M70.2342 54.8289V60.7048H68.5912V46.5756H72.4666C74.1997 46.5756 75.4786 46.9074 76.3033 47.571C77.1345 48.2346 77.55 49.2333 77.55 50.567C77.55 52.4354 76.6029 53.6982 74.7087 54.3554L78.5454 60.7048H76.6029L73.1818 54.8289H70.2342ZM70.2342 53.4179H72.4859C73.6457 53.4179 74.4961 53.1892 75.0373 52.7318C75.5785 52.2679 75.8491 51.5753 75.8491 50.6539C75.8491 49.7197 75.5721 49.0464 75.018 48.6341C74.4703 48.2218 73.5877 48.0156 72.37 48.0156H70.2342V53.4179Z",
  fill: "white"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M91.7047 53.6209C91.7047 55.8823 91.1313 57.6605 89.9845 58.9556C88.8441 60.2506 87.2559 60.8981 85.22 60.8981C83.1389 60.8981 81.5315 60.2635 80.3975 58.9942C79.27 57.7185 78.7063 55.921 78.7063 53.6015C78.7063 51.3014 79.2732 49.52 80.4072 48.2572C81.5411 46.988 83.1518 46.3533 85.2393 46.3533C87.2688 46.3533 88.8538 46.9976 89.9941 48.2862C91.1345 49.5748 91.7047 51.353 91.7047 53.6209ZM80.4458 53.6209C80.4458 55.5344 80.8517 56.9873 81.6635 57.9795C82.4818 58.9652 83.6673 59.4581 85.22 59.4581C86.7856 59.4581 87.9679 58.9652 88.7668 57.9795C89.5657 56.9937 89.9652 55.5408 89.9652 53.6209C89.9652 51.7202 89.5657 50.2803 88.7668 49.3009C87.9743 48.3152 86.7985 47.8223 85.2393 47.8223C83.6737 47.8223 82.4818 48.3184 81.6635 49.3106C80.8517 50.2964 80.4458 51.7331 80.4458 53.6209Z",
  fill: "white"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M102.438 50.6926C102.438 52.1229 101.949 53.2246 100.969 53.9978C99.9964 54.7645 98.6015 55.1478 96.7847 55.1478H95.1224V60.7048H93.4795V46.5756H97.1422C100.673 46.5756 102.438 47.9479 102.438 50.6926ZM95.1224 53.7368H96.601C98.0571 53.7368 99.1105 53.5017 99.7613 53.0314C100.412 52.561 100.737 51.8072 100.737 50.7699C100.737 49.8357 100.431 49.1399 99.8192 48.6824C99.2072 48.225 98.2536 47.9963 96.9586 47.9963H95.1224V53.7368Z",
  fill: "white"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M111.896 60.7048H104.02V46.5756H111.896V48.0349H105.663V52.5868H111.519V54.0364H105.663V59.2358H111.896V60.7048Z",
  fill: "white"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M122.533 60.7048L120.774 56.2109H115.111L113.371 60.7048H111.709L117.295 46.5176H118.677L124.234 60.7048H122.533ZM120.262 54.7323L118.619 50.3543C118.406 49.8003 118.187 49.1205 117.962 48.3152C117.82 48.9337 117.617 49.6134 117.353 50.3543L115.691 54.7323H120.262Z",
  fill: "white"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M135.828 60.7048H133.953L126.231 48.8467H126.154C126.257 50.2384 126.308 51.5141 126.308 52.6738V60.7048H124.791V46.5756H126.647L134.349 58.3854H134.426C134.413 58.2114 134.384 57.6541 134.339 56.7134C134.294 55.7663 134.278 55.0898 134.291 54.6839V46.5756H135.828V60.7048Z",
  fill: "white"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M152.752 46.5756V55.718C152.752 57.3287 152.266 58.5948 151.293 59.5161C150.32 60.4374 148.983 60.8981 147.282 60.8981C145.582 60.8981 144.264 60.4342 143.33 59.5064C142.402 58.5787 141.938 57.303 141.938 55.6794V46.5756H143.581V55.7953C143.581 56.9744 143.903 57.8796 144.547 58.511C145.192 59.1424 146.139 59.4581 147.389 59.4581C148.581 59.4581 149.499 59.1424 150.143 58.511C150.787 57.8732 151.11 56.9615 151.11 55.776V46.5756H152.752Z",
  fill: "white"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M166.153 60.7048H164.278L156.557 48.8467H156.479C156.582 50.2384 156.634 51.5141 156.634 52.6738V60.7048H155.117V46.5756H156.972L164.675 58.3854H164.752C164.739 58.2114 164.71 57.6541 164.665 56.7134C164.62 55.7663 164.604 55.0898 164.617 54.6839V46.5756H166.153V60.7048Z",
  fill: "white"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M168.653 60.7048V46.5756H170.296V60.7048H168.653Z",
  fill: "white"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M185.059 53.6209C185.059 55.8823 184.486 57.6605 183.339 58.9556C182.199 60.2506 180.611 60.8981 178.575 60.8981C176.494 60.8981 174.886 60.2635 173.752 58.9942C172.625 57.7185 172.061 55.921 172.061 53.6015C172.061 51.3014 172.628 49.52 173.762 48.2572C174.896 46.988 176.506 46.3533 178.594 46.3533C180.623 46.3533 182.208 46.9976 183.349 48.2862C184.489 49.5748 185.059 51.353 185.059 53.6209ZM173.8 53.6209C173.8 55.5344 174.206 56.9873 175.018 57.9795C175.836 58.9652 177.022 59.4581 178.575 59.4581C180.14 59.4581 181.323 58.9652 182.121 57.9795C182.92 56.9937 183.32 55.5408 183.32 53.6209C183.32 51.7202 182.92 50.2803 182.121 49.3009C181.329 48.3152 180.153 47.8223 178.594 47.8223C177.028 47.8223 175.836 48.3184 175.018 49.3106C174.206 50.2964 173.8 51.7331 173.8 53.6209Z",
  fill: "white"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M197.871 60.7048H195.996L188.274 48.8467H188.197C188.3 50.2384 188.351 51.5141 188.351 52.6738V60.7048H186.834V46.5756H188.69L196.392 58.3854H196.469C196.457 58.2114 196.428 57.6541 196.382 56.7134C196.337 55.7663 196.321 55.0898 196.334 54.6839V46.5756H197.871V60.7048Z",
  fill: "white"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M45.9258 82.6964V68.5672H47.5687V82.6964H45.9258Z",
  fill: "white"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M61.1049 82.6964H59.23L51.5083 70.8383H51.4309C51.534 72.23 51.5856 73.5057 51.5856 74.6654V82.6964H50.0683V68.5672H51.9238L59.6263 80.377H59.7036C59.6907 80.203 59.6617 79.6457 59.6166 78.7051C59.5715 77.758 59.5554 77.0815 59.5683 76.6756V68.5672H61.1049V82.6964Z",
  fill: "white"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M67.9534 82.6964H66.3105V70.0265H61.8359V68.5672H72.428V70.0265H67.9534V82.6964Z",
  fill: "white"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M81.0547 82.6964H73.1783V68.5672H81.0547V70.0265H74.8212V74.5784H80.6778V76.0281H74.8212V81.2274H81.0547V82.6964Z",
  fill: "white"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M82.8101 82.6964V68.5672H84.453V81.2081H90.6865V82.6964H82.8101Z",
  fill: "white"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M91.7074 82.6964V68.5672H93.3504V81.2081H99.5838V82.6964H91.7074Z",
  fill: "white"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M108.481 82.6964H100.605V68.5672H108.481V70.0265H102.248V74.5784H108.104V76.0281H102.248V81.2274H108.481V82.6964Z",
  fill: "white"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M116.286 69.8333C114.734 69.8333 113.506 70.3519 112.604 71.3892C111.709 72.4201 111.261 73.8343 111.261 75.6318C111.261 77.4809 111.693 78.9112 112.556 79.9228C113.426 80.9278 114.663 81.4304 116.267 81.4304C117.253 81.4304 118.377 81.2532 119.64 80.8989V82.3388C118.661 82.7061 117.453 82.8897 116.016 82.8897C113.935 82.8897 112.327 82.2583 111.193 80.9955C110.066 79.7327 109.502 77.9384 109.502 75.6125C109.502 74.1564 109.773 72.8807 110.314 71.7854C110.862 70.6901 111.648 69.8461 112.672 69.2534C113.703 68.6607 114.914 68.3643 116.306 68.3643C117.788 68.3643 119.083 68.6349 120.191 69.1761L119.495 70.5871C118.425 70.0845 117.356 69.8333 116.286 69.8333Z",
  fill: "white"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M125.686 82.6964H124.043V70.0265H119.569V68.5672H130.161V70.0265H125.686V82.6964Z",
  fill: "white"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M141.581 68.5672V77.7096C141.581 79.3204 141.094 80.5864 140.121 81.5077C139.148 82.429 137.811 82.8897 136.111 82.8897C134.41 82.8897 133.092 82.4258 132.158 81.498C131.23 80.5703 130.766 79.2946 130.766 77.671V68.5672H132.409V77.787C132.409 78.966 132.731 79.8712 133.376 80.5026C134.02 81.134 134.967 81.4497 136.217 81.4497C137.409 81.4497 138.327 81.134 138.971 80.5026C139.615 79.8648 139.938 78.9531 139.938 77.7676V68.5672H141.581Z",
  fill: "white"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M145.588 76.8205V82.6964H143.945V68.5672H147.82C149.553 68.5672 150.832 68.899 151.657 69.5627C152.488 70.2263 152.904 71.2249 152.904 72.5586C152.904 74.427 151.957 75.6898 150.062 76.347L153.899 82.6964H151.957L148.535 76.8205H145.588ZM145.588 75.4095H147.84C148.999 75.4095 149.85 75.1808 150.391 74.7234C150.932 74.2595 151.203 73.5669 151.203 72.6456C151.203 71.7113 150.926 71.0381 150.372 70.6257C149.824 70.2134 148.941 70.0072 147.724 70.0072H145.588V75.4095Z",
  fill: "white"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M163.676 82.6964L161.917 78.2025H156.254L154.514 82.6964H152.852L158.438 68.5092H159.82L165.377 82.6964H163.676ZM161.405 76.7239L159.762 72.346C159.549 71.7919 159.33 71.1122 159.105 70.3068C158.963 70.9253 158.76 71.605 158.496 72.346L156.833 76.7239H161.405Z",
  fill: "white"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M165.934 82.6964V68.5672H167.577V81.2081H173.81V82.6964H165.934Z",
  fill: "white"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "M187.546 72.6842C187.546 74.1145 187.056 75.2163 186.077 75.9894C185.104 76.7561 183.709 77.1395 181.892 77.1395H180.23V82.6964H178.587V68.5672H182.25C185.78 68.5672 187.546 69.9396 187.546 72.6842ZM180.23 75.7285H181.709C183.165 75.7285 184.218 75.4933 184.869 75.023C185.52 74.5526 185.845 73.7988 185.845 72.7615C185.845 71.8273 185.539 71.1315 184.927 70.674C184.315 70.2166 183.361 69.9879 182.066 69.9879H180.23V75.7285Z",
  fill: "white"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  d: "M190.77 76.8205V82.6964H189.127V68.5672H193.003C194.736 68.5672 196.015 68.899 196.839 69.5627C197.671 70.2263 198.086 71.2249 198.086 72.5586C198.086 74.427 197.139 75.6898 195.245 76.347L199.081 82.6964H197.139L193.718 76.8205H190.77ZM190.77 75.4095H193.022C194.182 75.4095 195.032 75.1808 195.573 74.7234C196.115 74.2595 196.385 73.5669 196.385 72.6456C196.385 71.7113 196.108 71.0381 195.554 70.6257C195.006 70.2134 194.124 70.0072 192.906 70.0072H190.77V75.4095Z",
  fill: "white"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  d: "M212.241 75.6125C212.241 77.8739 211.667 79.6522 210.521 80.9472C209.38 82.2422 207.792 82.8897 205.756 82.8897C203.675 82.8897 202.067 82.2551 200.934 80.9858C199.806 79.7101 199.242 77.9126 199.242 75.5932C199.242 73.2931 199.809 71.5116 200.943 70.2488C202.077 68.9796 203.688 68.3449 205.775 68.3449C207.805 68.3449 209.39 68.9892 210.53 70.2778C211.671 71.5664 212.241 73.3446 212.241 75.6125ZM200.982 75.6125C200.982 77.526 201.388 78.9789 202.2 79.9711C203.018 80.9568 204.203 81.4497 205.756 81.4497C207.322 81.4497 208.504 80.9568 209.303 79.9711C210.102 78.9853 210.501 77.5325 210.501 75.6125C210.501 73.7118 210.102 72.2719 209.303 71.2926C208.51 70.3068 207.335 69.8139 205.775 69.8139C204.21 69.8139 203.018 70.31 202.2 71.3022C201.388 72.288 200.982 73.7247 200.982 75.6125Z",
  fill: "white"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  d: "M222.974 72.6842C222.974 74.1145 222.485 75.2163 221.505 75.9894C220.532 76.7561 219.138 77.1395 217.321 77.1395H215.658V82.6964H214.016V68.5672H217.678C221.209 68.5672 222.974 69.9396 222.974 72.6842ZM215.658 75.7285H217.137C218.593 75.7285 219.647 75.4933 220.297 75.023C220.948 74.5526 221.273 73.7988 221.273 72.7615C221.273 71.8273 220.967 71.1315 220.355 70.674C219.743 70.2166 218.79 69.9879 217.495 69.9879H215.658V75.7285Z",
  fill: "white"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  d: "M232.432 82.6964H224.556V68.5672H232.432V70.0265H226.199V74.5784H232.055V76.0281H226.199V81.2274H232.432V82.6964Z",
  fill: "white"
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  d: "M235.831 76.8205V82.6964H234.188V68.5672H238.063C239.796 68.5672 241.075 68.899 241.9 69.5627C242.731 70.2263 243.146 71.2249 243.146 72.5586C243.146 74.427 242.199 75.6898 240.305 76.347L244.142 82.6964H242.199L238.778 76.8205H235.831ZM235.831 75.4095H238.082C239.242 75.4095 240.092 75.1808 240.634 74.7234C241.175 74.2595 241.445 73.5669 241.445 72.6456C241.445 71.7113 241.168 71.0381 240.614 70.6257C240.067 70.2134 239.184 70.0072 237.966 70.0072H235.831V75.4095Z",
  fill: "white"
});

var _ref35 = /*#__PURE__*/React.createElement("path", {
  d: "M249.386 82.6964H247.743V70.0265H243.269V68.5672H253.861V70.0265H249.386V82.6964Z",
  fill: "white"
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  d: "M258.206 75.6318L261.975 68.5672H263.753L259.037 77.2168V82.6964H257.375V77.2941L252.668 68.5672H254.466L258.206 75.6318Z",
  fill: "white"
});

var _ref37 = /*#__PURE__*/React.createElement("path", {
  d: "M279.113 82.6964H277.238L269.516 70.8383H269.439C269.542 72.23 269.593 73.5057 269.593 74.6654V82.6964H268.076V68.5672H269.932L277.634 80.377H277.711C277.698 80.203 277.669 79.6457 277.624 78.7051C277.579 77.758 277.563 77.0815 277.576 76.6756V68.5672H279.113V82.6964Z",
  fill: "white"
});

var _ref38 = /*#__PURE__*/React.createElement("path", {
  d: "M289.489 82.6964H281.612V68.5672H289.489V70.0265H283.255V74.5784H289.112V76.0281H283.255V81.2274H289.489V82.6964Z",
  fill: "white"
});

var _ref39 = /*#__PURE__*/React.createElement("path", {
  d: "M295.593 82.6964H293.95V70.0265H289.475V68.5672H300.067V70.0265H295.593V82.6964Z",
  fill: "white"
});

var _ref40 = /*#__PURE__*/React.createElement("path", {
  d: "M313.149 82.6964H311.526L308.675 73.2351C308.54 72.8163 308.388 72.288 308.221 71.6501C308.053 71.0123 307.966 70.6289 307.96 70.5001C307.818 71.3505 307.592 72.2815 307.283 73.2931L304.519 82.6964H302.896L299.136 68.5672H300.876L303.108 77.2941C303.417 78.5182 303.643 79.6264 303.785 80.6186C303.959 79.4395 304.216 78.2863 304.558 77.1588L307.09 68.5672H308.829L311.487 77.2361C311.796 78.2347 312.057 79.3622 312.27 80.6186C312.392 79.7037 312.624 78.5891 312.966 77.2747L315.189 68.5672H316.928L313.149 82.6964Z",
  fill: "white"
});

var _ref41 = /*#__PURE__*/React.createElement("path", {
  d: "M330.02 75.6125C330.02 77.8739 329.446 79.6522 328.3 80.9472C327.159 82.2422 325.571 82.8897 323.535 82.8897C321.454 82.8897 319.846 82.2551 318.713 80.9858C317.585 79.7101 317.021 77.9126 317.021 75.5932C317.021 73.2931 317.588 71.5116 318.722 70.2488C319.856 68.9796 321.467 68.3449 323.554 68.3449C325.584 68.3449 327.169 68.9892 328.309 70.2778C329.45 71.5664 330.02 73.3446 330.02 75.6125ZM318.761 75.6125C318.761 77.526 319.167 78.9789 319.979 79.9711C320.797 80.9568 321.982 81.4497 323.535 81.4497C325.101 81.4497 326.283 80.9568 327.082 79.9711C327.881 78.9853 328.28 77.5325 328.28 75.6125C328.28 73.7118 327.881 72.2719 327.082 71.2926C326.289 70.3068 325.114 69.8139 323.554 69.8139C321.989 69.8139 320.797 70.31 319.979 71.3022C319.167 72.288 318.761 73.7247 318.761 75.6125Z",
  fill: "white"
});

var _ref42 = /*#__PURE__*/React.createElement("path", {
  d: "M342 82.6964H340.067L334.916 75.8444L333.437 77.1588V82.6964H331.795V68.5672H333.437V75.5738L339.845 68.5672H341.787L336.105 74.7041L342 82.6964Z",
  fill: "white"
});

var _ref43 = /*#__PURE__*/React.createElement("circle", {
  cx: 32.9874,
  cy: 5.72547,
  r: 4.39832,
  fill: "white"
});

var _ref44 = /*#__PURE__*/React.createElement("circle", {
  cx: 32.9874,
  cy: 56.3063,
  r: 4.39832,
  fill: "white"
});

var _ref45 = /*#__PURE__*/React.createElement("circle", {
  cx: 4.39832,
  cy: 34.3145,
  r: 4.39832,
  fill: "white"
});

var _ref46 = /*#__PURE__*/React.createElement("circle", {
  cx: 3.29874,
  cy: 57.4057,
  r: 3.29874,
  fill: "white"
});

var _ref47 = /*#__PURE__*/React.createElement("line", {
  x1: 4.22154,
  y1: 34.1377,
  x2: 32.8106,
  y2: 5.54864,
  stroke: "white",
  strokeWidth: 0.5,
  strokeDasharray: "0.5 0.5"
});

var _ref48 = /*#__PURE__*/React.createElement("line", {
  x1: 4.64832,
  y1: 34.3145,
  x2: 4.64832,
  y2: 56.3061,
  stroke: "white",
  strokeWidth: 0.5,
  strokeDasharray: "0.5 0.5"
});

var _ref49 = /*#__PURE__*/React.createElement("line", {
  x1: 32.9874,
  y1: 56.5563,
  x2: 4.39832,
  y2: 56.5563,
  stroke: "white",
  strokeWidth: 0.5,
  strokeDasharray: "0.5 0.5"
});

var _ref50 = /*#__PURE__*/React.createElement("line", {
  x1: 32.835,
  y1: 56.5044,
  x2: 4.2459,
  y2: 34.5128,
  stroke: "white",
  strokeWidth: 0.5,
  strokeDasharray: "0.5 0.5"
});

var _ref51 = /*#__PURE__*/React.createElement("line", {
  x1: 4.18067,
  y1: 56.1833,
  x2: 32.7698,
  y2: 5.60255,
  stroke: "white",
  strokeWidth: 0.5,
  strokeDasharray: "0.5 0.5"
});

var _ref52 = /*#__PURE__*/React.createElement("line", {
  x1: 32.7374,
  y1: 56.3063,
  x2: 32.7374,
  y2: 5.72556,
  stroke: "white",
  strokeWidth: 0.5,
  strokeDasharray: "0.5 0.5"
});

var SvgEuipnLogo = function SvgEuipnLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "xMinYMin meet",
    viewBox: "0 0 342 83",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEuipnLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/euipn_logo.26330ab6.svg";
export { ForwardRef as ReactComponent };